
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.73 15.059a3.52 3.52 0 00-3.515 3.515 3.52 3.52 0 003.515 3.516h4.98l.06-.003c.02 0 .038.003.058.003.647 0 1.172-.525 1.172-1.172v-9.2c0-1.56-.767-2.943-1.943-3.796l-3.986-6.54a1.177 1.177 0 00-1.619-.386l-2.94 1.824L18.186.576A1.17 1.17 0 0016.569.17L5.279 7.031H3.517c-.637 0-1.156-.51-1.172-1.142a1.174 1.174 0 011.172-1.143h2.168a1.172 1.172 0 000-2.344H3.516a3.521 3.521 0 00-3.42 2.701A1.156 1.156 0 000 5.566v19.747A4.693 4.693 0 004.688 30h20.625a4.682 4.682 0 004.447-3.203 1.172 1.172 0 00-2.223-.743 2.341 2.341 0 01-2.224 1.602H4.688a2.346 2.346 0 01-2.344-2.343V9.174c.366.13.76.201 1.172.201h21.797a2.346 2.346 0 012.343 2.344v3.34H23.73zm3.926 4.687H23.73a1.173 1.173 0 010-2.344h3.926v2.344zM9.793 7.031l6.98-4.241L18.02 4.9a1.18 1.18 0 00.169.286l1.09 1.844H9.793zm12.208 0l-1.296-2.193 1.979-1.227 2.085 3.42h-2.768z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    